import React, { lazy, useState, useEffect, startTransition } from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import youtubePlayIcon from "@icons/youtubePlayIcon";
import playButtonImage from "../../images/academy/play-button.png";
import heroImage from "../../images/academy/hero-thumb-3.png";
import * as styles from "./style.module.scss";
const Player = lazy(() => import("@components/Player"));

const {
  youtube,
  youtube__cover,
  youtube__cover__button,
  youtube__placeholder,
  youtube__placeholder__img,
  youtubeBlog
} = styles;

const Youtube = ({ videoId, placeholderImage, modifier, withCover = false }) => {
  const [showVideo, setShowVideo] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);  
  const [fallbackThumb, setFallbackThumb] = useState(false);
  const placeholderImageData = getImage(placeholderImage?.gatsbyImageData);

  useEffect(() => {
    if (!placeholderImageData && videoId) {
      const testImg = new Image();
      testImg.src = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
      testImg.onload = function () {
        // YouTube maxresdefault placeholder is usually 120x90 or very small
        if (this.naturalWidth <= 120) {
          setFallbackThumb(true);
        }
      };
    }
  }, [videoId, placeholderImageData]);
  
  return (
    <div className={`${youtube} ${modifier === 'blog' && youtubeBlog} ${withCover && youtube__cover}`}>
      {(!showVideo || !hasLoaded) && (
        <div className={youtube__placeholder}
          role="presentation"
          onClick={() => {
            startTransition(() => {
              setShowVideo(true);
            });
          }}
        >
          {withCover && playButtonImage ? (
            <img
              alt="play icon"
              src={playButtonImage}
              className={youtube__cover__button}
              loading="lazy"
            />  
          ) : youtubePlayIcon}
          {placeholderImageData ?
            <GatsbyImage
              image={placeholderImageData}
              alt="Youtube video image"
              className={youtube__placeholder__img}
            />
          : 
          <img
            alt="Youtube video cover"
            src={
              withCover && heroImage
                ? heroImage
                : `https://i.ytimg.com/vi/${videoId}/${fallbackThumb ? 'sddefault' : 'maxresdefault'}.jpg`
            }
            className={youtube__placeholder__img}
            loading="lazy"
          />
          }
        </div>
      )}
      {showVideo && <Player
          videoId={videoId}
          setHasLoaded={setHasLoaded}
        />
      }
    </div>
  );
};

export default Youtube;
